var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29289 5.01164C4.10536 5.19918 4 5.45353 4 5.71875V7.71875C4 7.98397 4.10536 8.23832 4.29289 8.42586C4.48043 8.61339 4.73478 8.71875 5 8.71875H19C19.2652 8.71875 19.5196 8.61339 19.7071 8.42586C19.8946 8.23832 20 7.98397 20 7.71875V5.71875C20 5.45353 19.8946 5.19918 19.7071 5.01164C19.5196 4.82411 19.2652 4.71875 19 4.71875H5C4.73478 4.71875 4.48043 4.82411 4.29289 5.01164Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29289 13.0116C4.10536 13.1992 4 13.4535 4 13.7188V19.7188C4 19.984 4.10536 20.2383 4.29289 20.4259C4.48043 20.6134 4.73478 20.7188 5 20.7188H11C11.2652 20.7188 11.5196 20.6134 11.7071 20.4259C11.8946 20.2383 12 19.984 12 19.7188V13.7188C12 13.4535 11.8946 13.1992 11.7071 13.0116C11.5196 12.8241 11.2652 12.7188 11 12.7188H5C4.73478 12.7188 4.48043 12.8241 4.29289 13.0116Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 13.0116C16.1054 13.1992 16 13.4535 16 13.7188V19.7188C16 19.984 16.1054 20.2383 16.2929 20.4259C16.4804 20.6134 16.7348 20.7188 17 20.7188H19C19.2652 20.7188 19.5196 20.6134 19.7071 20.4259C19.8946 20.2383 20 19.984 20 19.7188V13.7188C20 13.4535 19.8946 13.1992 19.7071 13.0116C19.5196 12.8241 19.2652 12.7188 19 12.7188H17C16.7348 12.7188 16.4804 12.8241 16.2929 13.0116Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7e5c055af085b38f005f91a5be2401db.svg";
export { ForwardRef as ReactComponent };